import { IAliasConfiguration, IViewConfigurationItem, IObjectTypeId, IConfiguration } from "../interfaces/configuration/IConfiguration";

import difference from "lodash/difference";
import isString from "lodash/isString";
import uniq from "lodash/uniq";
import { DisplaySettings } from "src/rematch/interfaces/states/IViewSettingsState";
import { getValueByKeyForBuiltInPropertyDef, isBuildinProperty, stringToBuiltinProperty } from "../constants/builtinProperties";

const getMappedAliasProperty = (map: Map<string, number>, aliasOrId: string | number): number =>
  isString(aliasOrId) ? map.get(aliasOrId) : aliasOrId;

const getBuiltinOrMappedAliasProperty = (map: Map<string, number>, aliasOrId: string | number): number => {
  // we make sure that we get back Id of the builtInProperty
  if ( isBuildinProperty(aliasOrId?.toString() ?? '') ) { 

    const builtInProperty = stringToBuiltinProperty(aliasOrId?.toString() ?? '');
    return getValueByKeyForBuiltInPropertyDef( builtInProperty.toString() );

  } else { 
    return getMappedAliasProperty(map, aliasOrId); 
  }
}

export const getObjectTypeId = (cfg: IAliasConfiguration, aliasOrId: string | number): number =>
  getMappedAliasProperty(cfg.objectTypeAliases, aliasOrId);

export const getObjectClassId = (cfg: IAliasConfiguration, aliasOrId: string | number): number =>
  getMappedAliasProperty(cfg.objectClassAliases, aliasOrId);

export const getObjectWorkflowStateId = (cfg: IAliasConfiguration, aliasOrId: string | number): number =>
  getMappedAliasProperty(cfg.objectWorkflowStateAliases, aliasOrId);

export const getPropertyId = (cfg: IAliasConfiguration, aliasOrId: string | number): number =>
  getBuiltinOrMappedAliasProperty(cfg.propertyAliases, aliasOrId);

export const getWorkflowId = (cfg: IAliasConfiguration, aliasOrId: string | number): number =>
  getMappedAliasProperty(cfg.workflowAliases, aliasOrId);

export const getObjectTypeAlias = (cfg: IAliasConfiguration, otID: number): string => {
  for (const [key, value] of cfg.objectTypeAliases.entries()) {
    if (value === otID) {
      return key;
    }
  }
  return undefined;
};

export const determineRootObjectTypes = (vc: IViewConfigurationItem): IObjectTypeId[] => {
  const objectTypesOfView = Array.from(vc.objectHierarchy.keys());
  const childObjectTypesOfView = Array.from(vc.objectHierarchy.values()).flatMap((objectHierarchyItem) => {
    return objectHierarchyItem.childObjectTypes.map(([childObjectTypeId, _]) => childObjectTypeId);
  });

  return difference(uniq(objectTypesOfView), uniq(childObjectTypesOfView));
};

export const isOwnProperty = (propertyName: string): boolean => {
  if(!propertyName) {
    return false;
  }
  const ownProperties = ["name","start","end"];
  return ownProperties.includes(propertyName.toLowerCase());
};

export const getGridColumns = (config: IConfiguration, displaySettings: DisplaySettings): string[] => {
  let columnCount = 0;
  for(const objectTypeConfiguration of config.objectTypeConfigurations.values()) {
    if(objectTypeConfiguration.gridColumns?.length > columnCount) {
      columnCount = objectTypeConfiguration.gridColumns.length;
    }
    if(displaySettings.gridColumns[objectTypeConfiguration.objectTypeId]?.length > columnCount) {
      columnCount = displaySettings.gridColumns[objectTypeConfiguration.objectTypeId].length;
    }
  }
  if(columnCount === 0) {
    return ["name","start","end"];
  }
  const columns: string[] = [];
  for(let i = 0; i < columnCount; i++) {
    columns.push(`text${i}`);
  }
  return columns;
};